import styled from 'styled-components';
export const Container = styled.div `
    width: 100%;
    height: 100%;
    display: flex;
    position: relative;
`;
Container.displayName = 'Container';
//# sourceMappingURL=index.js.map